(function () {
	'use strict';

	angular
        .module('styleVisualGuidelinesControllers')
        .factory('styleVisualGuidelinesService', service);

	service.$inject = ['$http', '$q'];

	function service($http, $q) {

		var service = {
		    getIcons: getIcons,
		};
		return service;

		////////////

		function getIcons() {
		    var reqUrl = '/assets/jsons/icons.json';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}
	}
})();
